var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasketball40PxSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "basketball",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 58,
    viewBox: "0 0 40 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 55,
    r: 3,
    fill: "#FF2E00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,48,34.142,33.521a19.531,19.531,0,0,0,5.474-10.054,19.315,19.315,0,0,0-1.138-11.345,19.725,19.725,0,0,0-7.367-8.813,20.309,20.309,0,0,0-22.222,0,19.725,19.725,0,0,0-7.367,8.813A19.315,19.315,0,0,0,.384,23.467,19.531,19.531,0,0,0,5.858,33.521Z",
    fill: "#FF2E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(12.5,12.5)",
    fill: "#ffffff",
    id: "icon_concepts:_sports_leisure",
    d: "M3.66,7.0016H2.03a5.3231,5.3231,0,0,1,1.01-2.71A8.7122,8.7122,0,0,1,3.66,7.0016Zm1.075,0h2.34v-4.97a5.4585,5.4585,0,0,0-3.24,1.44A9.2947,9.2947,0,0,1,4.735,7.0016Zm3.19-4.97v4.97h2.34a9.2947,9.2947,0,0,1,.9-3.53A5.4585,5.4585,0,0,0,7.925,2.0316Zm4.035,2.26a8.7122,8.7122,0,0,0-.62,2.71h1.63A5.3231,5.3231,0,0,0,11.96,4.2916ZM14,8.7516a.7555.7555,0,0,1-.75.75H11.72l-.76,1.52v2.38a.392.392,0,0,1-.24.35.5863.5863,0,0,1-.14.02.3274.3274,0,0,1-.26-.11l-1.02-1.01-1.59,1.06a.3975.3975,0,0,1-.42,0l-1.59-1.06-1.02,1.01a.3709.3709,0,0,1-.4.09.392.392,0,0,1-.24-.35v-2.38l-.76-1.52H1.75a.75.75,0,0,1,0-1.5h11.5A.749.749,0,0,1,14,8.75Zm-7.14.75H4.12l.63,1.27a.3175.3175,0,0,1,.04.16v1.56l.56-.55Zm1.98,2.55L7.5,9.8916l-1.34,2.16,1.34.9Zm2.05-2.55H8.14l1.51,2.44.56.55v-1.56a.3175.3175,0,0,1,.04-.16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketball40PxSelected);
export default __webpack_public_path__ + "static/media/basketball_40px_selected.79f56f457debf9a090d2f6b4a026e466.svg";
export { ForwardRef as ReactComponent };